export default __webpack_public_path__ + "static/media/raccoon_2.6bb6da88.png";